module.exports = __webpack_public_path__ + "line-awesome.4d42f5f0c62a8f51e876.ttf";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/line-awesome/line-awesome.ttf?v=1.1.
// module id = ../../../../../src/assets/vendors/base/fonts/line-awesome/line-awesome.ttf?v=1.1.
// module chunks = styles